import $ from 'jquery';
import 'slick-carousel';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $( document ).ready(function() {
      $('body').css('visibility','').addClass('uk-animation-fade uk-animation-fast');
    });

    $('.js-slick-gallery').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true,
      fade: true,
      asNavFor: '.js-slick-gallery-nav',
    });

    $('.js-slick-gallery-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      asNavFor: '.js-slick-gallery',
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
      ],
    });
    
  },
};

